<style scoped>

</style>
<template>
  <Modal
    v-model="modal"
    class="expense-modal"
    title="批量处理"
    width="800"
    :mask="false"
    draggable
    footer-hide
    :styles="{position: 'absolute', top: 0, left: 0}"
    @on-cancel="cancel"
  >
    <div>
      <slot name="footer" />
      <Table
        ref="assets"
        class="asset-table"
        size="small"
        :columns="columns"
        :data="selectedAssets"
        border
      />
    </div>
  </Modal>
</template>
<script>
  export default {
    props: {
      value: {
        type: Number,
      },
      assetColumnsBase: {
        type: Array,
      },
      selectedAssets: {
        type: Array,
      }
    },
    data() {
      return {
        modal: this.value === 1,
        params: {
          search:''
        }
      }
    },
    computed: {
      columns() {
        const _this = this
        const [a, b, c, d, e, f] = this.assetColumnsBase
        return [{ title: '编号',
                  key: 'uid',
                  fixed: 'left',
                  align: 'center',
                  //  width: 150, 
        }, c, d, e, f, {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 100,
          render(h, {index}) {
            return h('Button', {
              props: {
                size: 'small',

                
              },
              on: {
                click: () => {
                  _this.$emit('del', index)
                }
              }
            }, '删除')
          }
        }]
      }
    },
    watch: {
      value(new_val) {
        this.modal = new_val === 1
      },
    },
    methods: {
      doSearch() {

      },
      cancel() {
        this.$emit('input', 0)
      }
    }
  }
</script>
